export const DAO_CODE = 'TRAINING_ATTACHMENT' + '_DAO';